module.exports = __webpack_public_path__ + "static/media/image_fond.8d6a8163.jpg";